import { whiteColor, colorSupportRed600 } from 'assets/jss/material-dashboard-pro-react';

const alertBarStyle = (theme) => ({
	alertBarSection: {
		backgroundColor: whiteColor,
		paddingBottom: theme.spacing(4),
		paddingTop: theme.spacing(1),
	},
	alertBar: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		backgroundColor: colorSupportRed600,
		padding: theme.spacing(2),
		borderRadius: '16px',
		color: theme.palette.common.white,

		'&:not(:last-child)': {
			marginBottom: '1.25rem',
		},

		[theme.breakpoints.up('sm')]: {
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-between',
			padding: theme.spacing(2, 3),
		},
	},
	message: {
		display: 'flex',
		alignItems: 'baseline',
		marginBottom: theme.spacing(1),
		[theme.breakpoints.up('sm')]: {
			marginBottom: 0,
		},
	},
	icon: {
		marginRight: theme.spacing(2),
		position: 'relative',
		top: '4px',
		[theme.breakpoints.up('sm')]: {
			top: '2px',
		},
	},
	button: {
		color: theme.palette.common.white,
		textTransform: 'none',
		alignSelf: 'flex-start',
		left: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			alignSelf: 'center',
		},
	},
});

export default alertBarStyle;
